import React, { useEffect, useState, useRef } from 'react'
import { Row, Col } from "react-bootstrap"
import Select from 'react-select';
import { buildUrl } from '../helper/handler';
import { getFromApi } from '../utilities/NetUtilities'
import { Settimane } from '../helper/settimaneTurniLavoro';


function FiltriPerSettimana(props) {

    const [settimana, setSettimana] = useState(null)
    const [settimanaCorrente, setSettimanaCorrente] = useState(null)
    const { setMessage, setSettimanaFiltro } = props;
    const settimanaRef = useRef(settimana);

    const handleSettimana = (data) => {
        const settimanaAttuale = Settimane.find(s => s.value === data.value);
        setSettimanaCorrente(settimanaAttuale);
        setSettimana(settimanaAttuale);
    };

    useEffect(() => {
        settimanaRef.current = settimana;
      }, [settimana]);

    useEffect(() => {
        getFromApi(buildUrl('settimanaCorrenteTurniLavoro'), handleSettimana, setMessage);
        if (settimanaRef.current) {
            setSettimanaFiltro(settimanaRef.current.value)
        }
    }, [setMessage, setSettimanaFiltro]);

    const filtroChanged = (newSettimana) => {
        setSettimana(newSettimana);
        props.filtroChanged(newSettimana);
    }

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.data.value === settimanaCorrente.value ? '#e6f2ff' : provided.backgroundColor,
            fontWeight: state.data.value === settimanaCorrente.value ? 'bold' : 'normal',
            color: state.data.value === settimanaCorrente.value ? '#000000' : provided.color
        }),
    };

    return (
        <Row className='filtri'>
            <Col xl={6} sm={8} xs={12} id="settimana-filtro">
                <p className="inEvidenza">settimana</p>
                <Select
                    name="settimanainizio"
                    instanceId="settimana"
                    options={Settimane}
                    onChange={filtroChanged}
                    placeholder="Seleziona..."
                    value={settimana}
                    styles={customStyles}
                    id="settimana-filtro-select"
                />
            </Col>
        </Row>
    )
}

export default FiltriPerSettimana;